export const blockIconsTextformattingAssignmentNew = (
	<span className='material-symbols-outlined'>assignment</span>
);
